import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Table from "react-bootstrap/Table";

import "../Home/styles.css";

import { api } from "../../services/api";
import Rodape from "../../components/Footer/rodape";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { DashLayoutGridAutorizar } from "../../components/DashLayoutGridAutorizar";

import CircularProgress from "@mui/material/CircularProgress";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export const AutorizarCourseOn = () => {
  const _data = JSON.parse(sessionStorage.getItem("@Auth:data"));

  const navigate = useNavigate();

  const [inscricaoCourse, setInscricaoCourse] = useState([]);
  const [courseInscricaoAutorizar, setCourseInscricaoAutorizar] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const InscricaoOk = () =>
    toast.success("Inscrição autorizada com sucesso.", {
      position: "top-center",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  const InscriaoNot = () =>
    toast.info(":( Ops!, Nº de vagas excedidas.", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  const InscricaoWarning = () =>
    toast.info("Ops!, Não foi possível completar esta operação.", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const inscriCourse = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };

      const res = await api.get("/inscricao/listar", httpOptions);
      setInscricaoCourse(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    inscriCourse();
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [setInscricaoCourse]);

  const courseInscricaoAutoriza = async () => {
    try {
      const _params = {
        id: inscricaoCourse[0].sqpreinscricao,
      };

      const httpOptions = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };

      const res = await api.post("/inscricao/autorizar", _params, httpOptions);
      setCourseInscricaoAutorizar(res.data);
      InscricaoOk();
    } catch (error) {
      error
    }
  };

  useEffect(() => {
    courseInscricaoAutoriza();
  }, [setCourseInscricaoAutorizar]);

  const handleSubmitAutorizaCourse = async (e) => {
    e.preventDefault();

    if (
      inscricaoCourse[0].sqpreinscricao !== null ||
      inscricaoCourse[0].sqpreinscricao !== "undefined"
    ) {
      InscricaoOk();
      setTimeout(() => {
        courseInscricaoAutoriza();
        navigate("https://sesat1.sefaz.pb.gov.br/esat/sigecap/");
      }, 6500);
      return;
    }

    if (inscricaoCourse.sqpreinscricao) {
      courseInscricaoAutoriza();
      return;
    } else {
      InscriaoNot();
      return;
    }
  };

  return (
    <>
      <Header />
      <Menu />
      <DashLayoutGridAutorizar>
        <h3 style={{ color: "#ccc" }}>AUTORIZAR INSCRIÇÕES</h3>
        <hr style={{ color: "#ccc" }} />
        {isLoading !== false ? (
          <>
            <br />{" "}
            <center>
              <h4 style={{ color: "#568989" }}>Carregando.... </h4>
              <br />
              <CircularProgress />
            </center>
          </>
        ) : (
          <>
            {inscricaoCourse.length > 0 ? (
              <>
                {" "}
                <br />
                <Table variant="dark" responsive="xl">
                  <thead style={{ border: "none" }}>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>Curso</th>
                      <th>Início</th>
                      <th>Ações</th>
                    </tr>
                  </thead>

                  <tbody>
                    {inscricaoCourse.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item.nocolaborador}</td>
                          <td>{item.nopec}</td>
                          <td>
                            {" "}
                            {new Date(item.dtevento)
                              .toLocaleString("pt-BR", { timeZone: "UTC" })
                              .substr(0, 10)}{" "}
                          </td>
                          <td>
                            <button
                              type="submit"
                              onClick={handleSubmitAutorizaCourse}
                              className="login-form-btn-auto"
                            >
                              Autorizar
                            </button>
                          </td>
                          <br />
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <ToastContainer />
              </>
            ) : (
              <>
                <center>
                  <h5 style={{ color: "#898282", marginTop: "5rem" }}>
                    {" "}
                    Você não tem nenhuma inscrição para autorizar.{" "}
                  </h5>
                  <br />
                </center>
              </>
            )}
          </>
        )}

        <br />
      </DashLayoutGridAutorizar>
      <Rodape />
    </>
  );
};
